'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactElement, ReactNode } from 'react';

const queryClient = new QueryClient();

export default function QueryProvider({
  children,
}: Readonly<{
  readonly children: ReactNode;
}>): ReactElement {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
